import { Model } from "./model";

export class Language extends Model {
    code: string;
    name: string;
    locale: string;
    flag: string;
}


// WEBPACK FOOTER //
// ./src/models/language.model.ts